import React from "react";
import "../style/Header.css";

const Header = () => {
  return (
    <header className="blue-header">
      <div className="header-content">
        <h1 className="header-title">BackpackEMR</h1>
        <div className="vertical-line"></div>
        <h2 className="header-subtitle">Admin Tool</h2>
      </div>
    </header>
  );
};

export default Header;
